<script setup>
import { computed, defineProps } from "vue";
import { count } from "@/utils/format";

// Categories as bars, longest first, each labelled with its value
const props = defineProps({
  title: { type: String, required: true },
  note: { type: String, default: "" },
  // [{ x: "Word", y: 96 }]
  rows: { type: Array, required: true },
  format: { type: Function, default: count },
});

const sorted = computed(() => [...props.rows].sort((a, b) => b.y - a.y));
const max = computed(() => Math.max(1, ...sorted.value.map((row) => row.y)));
</script>

<template>
  <section class="card h-full p-5">
    <h3 class="card-title">{{ title }}</h3>
    <p v-if="note" class="card-note">{{ note }}</p>
    <ol v-if="sorted.length" class="mt-4 space-y-3">
      <li
        v-for="row in sorted"
        :key="row.x"
        class="group grid grid-cols-[minmax(0,8.5rem)_1fr] items-center gap-3 sm:grid-cols-[minmax(0,13rem)_1fr]"
        :title="`${row.x}: ${format(row.y)}`"
      >
        <span class="truncate text-sm text-primary dark:text-white">{{
          row.x
        }}</span>
        <span class="flex min-w-0 items-center gap-2">
          <span class="min-w-0 flex-1">
            <span
              class="block h-4 min-w-[2px] rounded-r bg-accent transition-opacity group-hover:opacity-75"
              :style="{ width: `${(row.y / max) * 100}%` }"
            />
          </span>
          <span
            class="w-12 shrink-0 text-sm font-medium tabular-nums text-secondary dark:text-night-muted"
            >{{ format(row.y) }}</span
          >
        </span>
      </li>
    </ol>
    <p v-else class="card-note mt-4">Nothing yet.</p>
  </section>
</template>
